const { generate: genId } = require("shortid");
const { assignIdsToHeaders } = require("../../utils/prismic-data-utils");

const transformCurrentPlansGroup = (
	group,
	allowOverrideDocumentLink = false
) => ({
	title: assignIdsToHeaders(group.primary.groupTitle),
	body: assignIdsToHeaders(group.primary.groupBody),
	id: genId(),
	docs: group.fields
		.map((doc, i) =>
			doc.documentSizeGroup.documentSizeGroup.map(docSize => ({
				group: {
					sortOrder: i,
					displayText: doc.documentSizeGroup.documentDisplayText,
					groupedRowsLength: group.fields.length,
				},
				url:
					allowOverrideDocumentLink && docSize.overrideDocumentLink
						? docSize.overrideDocumentLink.url
						: `/Division/Research/Documents/${docSize.documentName}`,
				...docSize,
			}))
		)
		.reduce((acc, val) => acc.concat(val), []),
});

const transformProposedPlansGroup = group => {
	return group.map((doc, i) =>
		doc.proposedMapDocuments.documentSizeGroup.map(docSize => ({
			group: {
				sortOrder: i,
				displayText: doc.proposedMapDocuments.documentDisplayText,
				groupedRowsLength: group.length,
			},
			url: `/Division/Research/Documents/${docSize.documentName}`,
			...docSize,
		}))
	);
};

const transformProposals = body => {
	const proposalGroup = {};
	let currentProposalId;
	let proposalIndex;

	body.forEach(slice => {
		switch (slice.type) {
			case "proposal-group-text":
				currentProposalId = genId();
				proposalGroup[currentProposalId] = {
					type: "rich-text",
					body: assignIdsToHeaders(
						slice.primary.proposalGroupRichText
					),
				};
				break;

			case "proposal":
				currentProposalId = genId();
				proposalGroup[currentProposalId] = {
					type: "group",
					title: assignIdsToHeaders(slice.primary.title),
					titlePlainText: slice.primary.title[0].text,
					billLink: slice.primary.billLink
						? slice.primary.billLink.url
						: null,
					body: assignIdsToHeaders(slice.primary.body4),
					overviewMaps: slice.fields.map(
						({ overviewMaps, overviewMapsTitle }) => ({
							title: assignIdsToHeaders(overviewMapsTitle),
							maps: assignIdsToHeaders(overviewMaps),
						})
					),
					proposals: [],
				};
				break;

			case "proposal-title":
				proposalGroup[currentProposalId].proposals.push({
					title: assignIdsToHeaders(slice.primary.proposalTitle),
					mapGroups: [],
				});
				proposalIndex =
					proposalGroup[currentProposalId].proposals.length - 1;
				break;

			case "proposal-map-group":
				proposalGroup[currentProposalId].proposals[
					proposalIndex
				].mapGroups.push({
					title: assignIdsToHeaders(
						slice.primary.proposalMapGroupTitle
					),
					groups: transformProposedPlansGroup(slice.fields).reduce(
						(acc, val) => acc.concat(val),
						[]
					),
				});
				break;
		}
	});
	return proposalGroup;
};

module.exports.transformDistrictPlansPageData = data =>
	data.prismic.allReapredistDistrictPlansPages.edges.map(({ node }) => ({
		showCurrentDistrictsTab: node.showCurrentDistrictsTab,
		showFinalDistrictsTab: node.showFinalDistrictsTab,
		showLegislativeProposalsTab: node.showLegislativeProposalsTab,
		showPublicProposalsTab: node.showPublicProposalsTab,
		currentDistricts: {
			mainBodyText: assignIdsToHeaders(node.mainBodyTextCurrent),
			groups: node.body
				? node.body.map(group =>
						transformCurrentPlansGroup(group, true)
				  )
				: null,
		},
		legislativeProposals: {
			mainBodyText: assignIdsToHeaders(node.mainBodyTextLegislative),
			proposals: node.body1 ? transformProposals(node.body1) : null,
		},
		publicProposals: {
			mainBodyText: assignIdsToHeaders(node.mainBodyTextPublic),
			proposals: node.body2 ? transformProposals(node.body2) : null,
		},
		finalDistricts: {
			mainBodyText: assignIdsToHeaders(node.mainBodyTextFinal),
			groups: node.body3
				? node.body3.map(group =>
						transformCurrentPlansGroup(group, true)
				  )
				: null,
		},
	}))[0];
